import { useQuery } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * tRPC-only — there is no GraphQL equivalent, so this is a thin `useQuery`
 * wrapper rather than a `createQueryHook` bridge.
 */
export const useGetScheduleTaskTypes = () => {
  const trpc = useTRPC();

  return useQuery(trpc.frontend.scheduler.getTaskTypes.queryOptions());
};
